import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompanyUrlFileId } from '../app/Interfaces/ifiles';
import { IgeneralResponse03 } from '../app/Interfaces/igeneralresponse02';
import { IPASId } from '../app/Interfaces/ipas';
import { environment } from '../environments/environment';
import { DataService } from './data.service';

@Injectable()
export class InventoryService {
  private storage: any;

  baseUrl = environment.urlAPI;

  constructor(private http: HttpClient, private dataService: DataService) { }

  public SavePASInCCs(pPasId: number)
  {
    try {
      const data: IPASId=
      {
        pasId: pPasId
      }
      let url = this.baseUrl + 'api/inventory/v1/pas/cc/';
      return this.dataService.put<IgeneralResponse03>(url, data)
        .pipe(res => { return res });
    }
    catch (e) {
      console.log("Error");
    }
  }

  ///Obj: Upload inventory form url file , only new items
  public UpUrlFile(id: number) {
    try {
      const data: CompanyUrlFileId =
      {
        id: id
      };
      let url = this.baseUrl + 'api/inventory/v1/pascc/upload/url/';
      return this.dataService.post<IgeneralResponse03>(url, data)
        .pipe(res => { return res });
    }
    catch (e) {
      console.log("Error");
    }
  }

  

}
